const onlyDigits = (value = "") => String(value).replace(/\D+/g, "");
const BOLETO_LIST_URL = "/segunda-via-de-boleto/lista-boletos";
const BOLETO_LIST_HASH = "segunda-via-boleto-bb";

const formatDocumento = (value = "") => {
  const digits = onlyDigits(value).slice(0, 14);

  if (digits.length > 11) {
    return digits
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2");
  }

  return digits
    .replace(/^(\d{3})(\d)/, "$1.$2")
    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1-$2");
};

const buildRow = (item) => {
  const actionCell = item.download_url
    ? `<a class="segunda-via-boleto__download" href="${item.download_url}" target="_blank" rel="noopener noreferrer">Baixar segunda via</a>`
    : '<span class="segunda-via-boleto__download segunda-via-boleto__download--disabled">Indisponível</span>';

  return `
    <tr>
      <td>${item.nosso_numero || "-"}</td>
      <td>${item.nosso_documento || "-"}</td>
      <td>${item.emissao || "-"}</td>
      <td>${item.vencimento || "-"}</td>
      <td>${item.valor || "-"}</td>
      <td>${actionCell}</td>
    </tr>
  `;
};

const renderItems = (tableBody, items) => {
  if (!Array.isArray(items) || !items.length) {
    tableBody.innerHTML = "";
    return;
  }
  tableBody.innerHTML = items.map((item) => buildRow(item)).join("");
};

const abrirItau = async (documento, ajaxUrl, itauNonce) => {
  const body = new URLSearchParams();
  body.append("action", "itau_gerar_hash");
  body.append("nonce", itauNonce);
  body.append("campo", documento);

  const response = await fetch(ajaxUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: body.toString(),
  });

  const payload = await response.json();

  if (!payload?.success) {
    throw new Error("Falha ao gerar hash Itaú.");
  }

  const frmItau = document.getElementById("frmItau");
  if (!frmItau) return;

  const dcInput = frmItau.querySelector('input[name="DC"]');
  const cpfInput = frmItau.querySelector('input[name="cpf-cnpj"]');

  if (!dcInput || !cpfInput) return;

  dcInput.value = payload.data.chave;
  cpfInput.value = documento;

  frmItau.submit();
};

export function initSegundaViaBoleto() {
  const blocks = Array.from(
    document.querySelectorAll(".js-segunda-via-boleto"),
  );

  blocks.forEach((block) => {
    const form = block.querySelector(".segunda-via-boleto__form");
    const input =
      block.querySelector < HTMLInputElement > ".segunda-via-boleto__input";
    const message = block.querySelector(".js-bb-message");
    const tableWrap = block.querySelector < HTMLElement > ".js-bb-table-wrap";
    const tableBody = block.querySelector(".js-bb-table-body");
    const submitButton =
      block.querySelector < HTMLButtonElement > ".segunda-via-boleto__button";

    const ajaxUrl = block.dataset.ajaxUrl;
    const nonce = block.dataset.nonce;
    const itauNonce = block.dataset.itauNonce;

    if (
      !form ||
      !input ||
      !message ||
      !tableWrap ||
      !tableBody ||
      !submitButton ||
      !ajaxUrl ||
      !nonce
    ) {
      return;
    }

    input.addEventListener("input", () => {
      input.value = formatDocumento(input.value);
    });

    form.addEventListener("submit", (event) => {
      console.log("submit");
      event.preventDefault();

      const documento = onlyDigits(input.value);

      if (documento.length !== 11 && documento.length !== 14) {
        message.textContent =
          "Documento inválido. Informe um CPF ou CNPJ com 11 ou 14 dígitos.";
        message.classList.add("is-error");
        return;
      }

      const redirectUrl = new URL(BOLETO_LIST_URL, window.location.origin);
      redirectUrl.searchParams.set("documento", documento);
      redirectUrl.hash = BOLETO_LIST_HASH;

      window.location.href = redirectUrl.toString();
    });
  });
}
